import type { ComponentProps } from 'react';
import { forwardRef, useCallback } from 'react';

import type { DocumentEntity } from '@izimi/modules';
import type { FirstParameter } from '@izimi/utils';

import ContextMenu from '../../../ContextMenu/ContextMenu';
import TrashDocumentsTableOptionsMenu from './TrashDocumentsTableOptionsMenu';

interface Props {
  document: DocumentEntity;
}

const TrashDocumentsTableContextMenu = forwardRef<HTMLElement, Props>(({ document }, ref) => {
  const Menu = useCallback(
    (props: FirstParameter<ComponentProps<typeof ContextMenu>['Menu']>) => (
      <TrashDocumentsTableOptionsMenu {...props} document={document} />
    ),
    [document],
  );

  return <ContextMenu ref={ref} Menu={Menu} />;
});

export default TrashDocumentsTableContextMenu;
